import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import FloatingReserve from "@/components/FloatingReserve";
import { useContent } from "@/context/ContentContext";

export default function Layout() {
  const { content } = useContent();
  return (
    <div className="relative min-h-screen bg-[#16120e]">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-white focus:text-black focus:px-4 focus:py-2 focus:rounded-lg" data-testid="skip-to-content">Skip to main content</a>
      <Navbar />
      <main id="main-content" tabIndex={-1} className="relative z-10 outline-none">
        <Outlet />
      </main>
      <Footer content={content} />
      <ScrollToTop />
      <FloatingReserve />
    </div>
  );
}
